import React from 'react';

const WhySofia = () => {
  return (
    <section id="why-sofia" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        {/* Header Section */}
        <div className="flex flex-wrap justify-center text-center mb-24">
          <div className="w-full lg:w-6/12 px-4">
            <h2 className="text-4xl font-semibold text-black">Why Sofia?</h2>
            <p className="text-lg leading-relaxed mt-4 text-gray-500">
              Identifying the Need for Flawless Content
            </p>
          </div>
        </div>

        {/* Card Container */}
        <div className="flex flex-wrap gap-6 -mx-2">
          {/* Card 1 */}
          <div className="w-full md:w-4/12 px-2">
            <div className="text-center p-8 bg-gray-50 rounded-lg">
              <div className="text-gray-500 p-6 inline-flex items-center justify-center rounded-full">
                {/* <i className="fa-solid fa-image text-4xl text-black"></i> */}
                <img src={require("assets/icon/img.png")}

alt="Proofreading & Editing" className="w-16 h-16" />
              </div>
              <h6 className="text-xl font-semibold text-black mt-4">Professional Image</h6>
              <p className="mt-2 text-gray-500">
                Errors can damage your credibility. Sofia ensures a professional image. We eliminate mistakes.
              </p>
            </div>
          </div>

          {/* Card 2 */}
          <div className="w-full md:w-4/12 px-2">
            <div className="text-center p-8 bg-gray-50 rounded-lg">
              <div className="text-gray-500 p-6 inline-flex items-center justify-center rounded-full">
                {/* <i className="fas fa-comments text-4xl text-black"></i> */}
                <img src={require("assets/icon/conversation2.png")}

alt="Proofreading & Editing" className="w-16 h-16" />
              </div>
              <h6 className="text-xl font-semibold text-black mt-4">Clear Communication</h6>
              <p className="mt-2 text-gray-500">
                We enhance clarity and coherence. Sofia ensures your message is easily understood. We refine your narrative.
              </p>
            </div>
          </div>

          {/* Card 3 */}
          <div className="w-full md:w-4/12 px-2">
            <div className="text-center p-8 bg-gray-50 rounded-lg">
              <div className="text-gray-500 p-6 inline-flex items-center justify-center rounded-full bg-gray-200">
                {/* <i className="fas fa-bullseye text-4xl text-black"></i> */}
                <img src={require("assets/icon/target.png")}

alt="Proofreading & Editing" className="w-16 h-16" />
              </div>
              <h6 className="text-xl font-semibold text-black mt-4">Impactful Messaging</h6>
              <p className="mt-2 text-gray-500">
                Polished content captivates readers. Sofia helps you make a lasting impression. We optimize your content.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhySofia;